<template>
  <div
    class="rounded-circle conn-indicator"
    :class="{ 'bg-success': isOnline, 'bg-danger': !isOnline }"
  ></div>
</template>
<script setup>
import { useIntervalFn } from '@vueuse/core'
import { useApi } from '@/composables/api'
import config from '@/config'

const interval = Number(config.VITE_VORTEX_STATUS_INTERVAL ?? 30000)
const { model: isOnline, refresh } = useApi({ url: 'vortex_status', pick: d => d.online })
if (interval > 0) {
  useIntervalFn(refresh, interval, { immediate: true, immediateCallback: true })
}
</script>
